import { FC } from 'react';
import { AdminCardPriceSettings } from 'containers/admin';
import { AdminCardLayout } from 'pages/atoms';

const AdminCardPriceSettingsPage: FC = () => {
  return (
    <AdminCardLayout>
      <AdminCardPriceSettings />
    </AdminCardLayout>
  );
};

export default AdminCardPriceSettingsPage;
